import Vue from 'vue'
import Meta from 'vue-meta'
Vue.use(Meta)



// WEBPACK FOOTER //
// ./src/plugins/vue-meta.js